// packages
import { Component } from "react";
import { Link } from "react-router-dom";
import { Animation } from "@devexpress/dx-react-chart";

// Views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";

// Styles
import "./superAdmin.css";

// Assets
import backArrow from "../../assets/images/backArrow.png";
import vdoIcon from "../../assets/images/vdoIcon.png";
import imgIcon from "../../assets/images/imgIcon.png";
import otherIcon from "../../assets/images/otherIcon.png";
import documentIcon from "../../assets/images/documentIcon.png";

// Material Ui
import { Chart, PieSeries } from "@devexpress/dx-react-chart-material-ui";

const chartdata = [
  { storageType: "free", area: 12 },
  { storageType: "occupied", area: 7 },
];

class StorageDetails extends Component {
  componentDidMount() {
    document.getElementById("Storage").classList.add("active");
  }
  render() {
    return (
      <div className="">
        <SuperAdminDashboard />
        <div className="content-layout p-0">
          <div className="top-strip">
            <div className="container">
              <div className="row p-16">
                <div className="col-6 mt-10">
                  <p>
                    <Link to="/storage">
                      <span className="fs-22 black semi-bold">STORAGE</span>
                    </Link>{" "}
                    <img src={backArrow} alt="back arrow"></img>
                    <span className="fs-22 black  semi-bold">
                      {" "}
                      Alabama Crimson Tide football
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div>
              <div className="container mt-20 pl-4">
                <div className="row">
                  <div className="col-6 rightBorder-grey">
                    <div className="row">
                      <div className="col-8" id="chartstyle">
                        <Chart data={chartdata}>
                          <PieSeries
                            valueField="area"
                            argumentField="storageType"
                          />
                          <Animation />
                        </Chart>
                        <p className="txt-center txt-blue semi-bold">
                          301 GB used of 1024 GB Used
                        </p>
                      </div>
                      <div className="col-4">
                        <label>Storage Overview</label>
                        <div className="row">
                          <div className="col-2 ">
                            <div className="freeStorage"></div>
                          </div>
                          <div className="col-8 txtlightgrey">
                            <label>Free</label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-2">
                            <div className="occupiedStorage"></div>
                          </div>
                          <div className="col-8 txtlightgrey">
                            <label>Occupied</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16 txt-blue">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-6">
                            <label>Last Upgraded On :</label>
                          </div>
                          <div className="col-6 p-0">
                            <p>22/03/2021</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <p>Upgrade Storage</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={vdoIcon} alt="video icon"></img>
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Videos</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">200GB</p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={imgIcon} alt="icon"></img>
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Images</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">500GB</p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={documentIcon} alt="document icon"></img>
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Doucments/Notes</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">1GB</p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="row fs-16">
                      <div className="col-8">
                        <div className="row">
                          <div className="col-1"></div>
                          <div className="col-2 mr-4">
                            <label>
                              <img src={otherIcon} alt="others icon"></img>
                            </label>
                          </div>
                          <div className="col-6 p-0">
                            <div>Others</div>
                            <div className="txtlightgrey">120 files</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-2">
                        <p className="txt-center storagewhite-box">50GB</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StorageDetails;
